import React from 'react';

export default function SecurityCircle() {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z'
        fill='#27272A'
      />
      <path
        d='M15.9993 22.6666C15.9993 22.6666 21.3327 19.9999 21.3327 15.9999V11.3333L15.9993 9.33325L10.666 11.3333V15.9999C10.666 19.9999 15.9993 22.6666 15.9993 22.6666Z'
        stroke='#A1A1AA'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
